import React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { useParams, useLocation } from 'react-router-dom'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../../layouts/TextStyles'
import SubjectAnalyticsTable from './components/SubjectAnalyticsTable'
import { subjectApiSlice } from '../../../../features/subject/subjectSlice'
import { capitalize } from '../../../../utils/functions'
import Sentinel from '../../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../../app/hooks/usePaginatedList'
import { ui } from '../../../../utils/uiTokens'

const SubjectAnalyticsPage = () => {
    const { locale } = useIntl()
    const { courseId } = useParams()
    const { state } = useLocation()
    const [fetchAnalytics] = subjectApiSlice.useLazyFetchAnalyticsQuery()

    const { rows, isLoading, loadedPages, sentinelRef } = usePaginatedList(
        (page, size) =>
            fetchAnalytics({ page, size, courseId: Number(courseId) }).unwrap(),
        [courseId],
    )

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {state?.course?.[`courseTitle${capitalize(locale)}`] || "Пән"} аналитикасы</H3>
                    </Title>
                </Header>

                {isLoading && loadedPages === 0 ? (
                    <LinearProgress />
                ) : (
                    <>
                        <SubjectAnalyticsTable
                            isFetching={isLoading}
                            analyticsData={rows}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default SubjectAnalyticsPage


const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
